import {Component, Inject, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {ProjectService} from '../../../../shared/services/project/project.service';
import {IconService} from '../../../../shared/services/icon/icon.service';

@Component({
  selector: 'app-upload-plan',
  templateUrl: './upload-plan.component.html',
  styleUrls: ['./upload-plan.component.scss']
})
export class UploadPlanComponent implements OnInit {

  files: any[];
  showSpinner: boolean = false;
  private idProject;
  private filesInvalidType: File[] = [];
  private filesInvalidSize: File[] = [];
  private acceptedMimeTypes: string[] = [
    'image/jpeg',
    'image/png'
  ];
  private acceptedMaximumSize = 20000000;
  private planUploadedSubscription: Subscription;

  constructor(
    public iconService: IconService,
    private projectService: ProjectService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private modalRef: MatDialogRef<UploadPlanComponent>,
    @Inject(MAT_DIALOG_DATA) public  data
  ) {
  }

  ngOnInit() {
    if (!this.data) {
      this.idProject = this.route.snapshot.paramMap.get('id');
    } else {
      this.idProject = this.data.idProject;
    }
  }

  addFiles(files: File[]) {
    this.spliceInvalidFiles(files);
    if (this.filesInvalidType.length > 0) {
      this.alertError(this.filesInvalidType, 'type');
    }
    if (this.filesInvalidSize.length > 0) {
      this.alertError(this.filesInvalidSize, 'size');
    }
    this.files.forEach(
      (file: any, index) => this.dataUrl(file)
        .then((src: any) => {
          this.files[index].encodedImage = src;
        })
    );
  }

  dataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent<FileReader>) => resolve(event.target.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  submitFiles() {
    this.showSpinner = true;
    let requests: Observable<any>[] = this.files.map(
      (file) => {
        const uploadData = new FormData();
        uploadData.append('project', this.idProject);
        uploadData.append('name', file.name);
        uploadData.append('active', 'true');
        uploadData.append('imageFile', file);
        return this.projectService.postProjectPlan(uploadData);
      }
    );
    this.planUploadedSubscription = forkJoin(requests)
      .subscribe(
        () => {
          this.toastr.success((requests.length > 0 ? 'Plans ' : 'Plan ') + 'uploaded');
          this.modalRef.close();
        },
        () => this.showSpinner = false
      );
  }

  private spliceInvalidFiles(files): void {
    this.files = [];
    this.filesInvalidType = [];
    this.filesInvalidSize = [];
    files.forEach(
      (file) => {
        let typeValid = this.acceptedMimeTypes.includes(file.type);
        let sizeValid = file.size < this.acceptedMaximumSize;
        if (!typeValid) {
          this.filesInvalidType.push(file);
        } else if (!sizeValid) {
          this.filesInvalidSize.push(file);
        } else {
          this.files.push(file);
        }
      }
    );
  }

  private alertError(invalidFiles: File[], error: 'type' | 'size') {
    let invalidFilesNameString = invalidFiles
      .reduce(
        (namesString, file, index) => namesString + (index > 0 ? ', ' : '') + file.name, ' '
      );
    let message = error === 'type' ?
      'The following files have invalid types (only png / jpg allowed) :'
      : 'The following files have invalid size (until 20 Mo allowed) :';
    this.toastr.error(message + invalidFilesNameString);
    // this.translateService.get('Invalid fields')
    //     .subscribe(
    //         (translatedMessage) => this.toastr.info(translatedMessage + invalidFilesNameString)
    //     );
  }

}
